module.exports = __webpack_public_path__ + "static/media/crocodile(5).071c6a78.PNG";